import { createRoutine } from 'redux-saga-routines'
import { call, put, takeLatest } from '@redux-saga/core/effects'
import { toast } from 'react-toastify'
import * as estateService from 'services/estateService'

export const listEstatesRoutine = createRoutine('ESTATES_LIST')
export const createEstateRoutine = createRoutine('ESTATES_CREATE')
export const updateEstateRoutine = createRoutine('ESTATES_UPDATE')
export const deleteEstateRoutine = createRoutine('ESTATES_DELETE')
export const syncEstateBpsRoutine = createRoutine('ESTATES_SYNC_BPS')
export const attachEstatePortfolioRoutine = createRoutine('ESTATES_ATTACH_PORTFOLIO')
export const detachEstatePortfolioRoutine = createRoutine('ESTATES_DETACH_PORTFOLIO')

function* listEstates({ payload }) {
  yield put(listEstatesRoutine.request())
  try {
    const { data } = yield call(estateService.listMyEstates, payload?.page || 1)
    yield put(listEstatesRoutine.success({ ...data, page: payload?.page || 1 }))
  } catch (error) {
    yield put(listEstatesRoutine.failure(error))
    toast.error('Could not load your estates.')
  }
}

function* createEstate({ payload }) {
  yield put(createEstateRoutine.request())
  try {
    yield call(estateService.createEstate, payload)
    yield put(createEstateRoutine.success())
    toast.success('Estate created.')
    yield put(listEstatesRoutine({ page: 1 }))
  } catch (error) {
    yield put(createEstateRoutine.failure(error))
    toast.error('Could not create the estate.')
  }
}

function* updateEstate({ payload }) {
  yield put(updateEstateRoutine.request())
  try {
    const { id, buildingPassportIds, detachBpIds, ...fields } = payload
    yield call(estateService.updateEstate, { id, ...fields })
    if (buildingPassportIds?.length) {
      yield call(estateService.attachBps, { id, buildingPassportIds })
    }
    for (const bpId of detachBpIds || []) {
      yield call(estateService.detachBp, { id, bpId })
    }
    yield put(updateEstateRoutine.success())
    toast.success('Estate updated.')
    yield put(listEstatesRoutine({ page: 1 }))
  } catch (error) {
    yield put(updateEstateRoutine.failure(error))
    toast.error('Could not update the estate.')
  }
}

function* deleteEstate({ payload }) {
  yield put(deleteEstateRoutine.request())
  try {
    yield call(estateService.deleteEstate, payload.id)
    yield put(deleteEstateRoutine.success())
    toast.success('Estate deleted.')
    yield put(listEstatesRoutine({ page: 1 }))
  } catch (error) {
    yield put(deleteEstateRoutine.failure(error))
    toast.error('Could not delete the estate.')
  }
}

function* attachEstatePortfolio({ payload }) {
  yield put(attachEstatePortfolioRoutine.request())
  try {
    yield call(estateService.attachToPortfolio, payload)
    yield put(attachEstatePortfolioRoutine.success())
    toast.success('Estate added to portfolio.')
    yield put(listEstatesRoutine({ page: 1 }))
  } catch (error) {
    yield put(attachEstatePortfolioRoutine.failure(error))
    toast.error('Could not add the estate to the portfolio.')
  }
}

function* detachEstatePortfolio({ payload }) {
  yield put(detachEstatePortfolioRoutine.request())
  try {
    yield call(estateService.detachFromPortfolio, payload.id)
    yield put(detachEstatePortfolioRoutine.success())
    toast.success('Estate removed from portfolio.')
    yield put(listEstatesRoutine({ page: 1 }))
  } catch (error) {
    yield put(detachEstatePortfolioRoutine.failure(error))
    toast.error('Could not remove the estate from the portfolio.')
  }
}

export function* estatesSagas() {
  yield takeLatest(listEstatesRoutine.TRIGGER, listEstates)
  yield takeLatest(createEstateRoutine.TRIGGER, createEstate)
  yield takeLatest(updateEstateRoutine.TRIGGER, updateEstate)
  yield takeLatest(deleteEstateRoutine.TRIGGER, deleteEstate)
  yield takeLatest(attachEstatePortfolioRoutine.TRIGGER, attachEstatePortfolio)
  yield takeLatest(detachEstatePortfolioRoutine.TRIGGER, detachEstatePortfolio)
}
